var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { PageService } from "~/utils/page.service";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var ApplyHistory = /** @class */ (function (_super) {
    __extends(ApplyHistory, _super);
    function ApplyHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            applyCategory: "",
            applyStatus: "",
            applyRealName: "",
            approvalRealName: "",
            caseNumber: ""
        };
        _this.dataSet = [];
        return _this;
    }
    ApplyHistory.prototype.onCaseNumberChange = function (val) {
        if (!val)
            return;
        this.refreshData();
    };
    // 刷新数据
    ApplyHistory.prototype.refreshData = function () {
        var _this = this;
        // this.model.caseId = this.caseId;
        this.model.caseNumber = this.caseNo;
        this.caseOperatorPageService
            .caseApplyHistory(this.model, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    ApplyHistory.prototype.activated = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], ApplyHistory.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], ApplyHistory.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], ApplyHistory.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], ApplyHistory.prototype, "caseNo", void 0);
    __decorate([
        Watch("caseNo", { immediate: true })
    ], ApplyHistory.prototype, "onCaseNumberChange", null);
    ApplyHistory = __decorate([
        Component
    ], ApplyHistory);
    return ApplyHistory;
}(Vue));
export default ApplyHistory;
